import api from './api';

export interface ItemServico {
  codigo: string;
  descricao: string;
}

export const getItemsServico = (values: any) =>
  api.post<ItemServico[]>('itemServico', values, { disableNotification: true });
export const getItemsServicoOptions = (values: any) =>
  getItemsServico(values).then(itemServico =>
    (itemServico || []).map(item => ({ text: item.descricao, value: item.codigo })),
  );
export const getItemByCodigo = (codigo: string) => api.get(`itemServico/codigo/${codigo}`);
export const getItemsServicoOptionByCodigo = (codigo: string) =>
  getItemByCodigo(codigo).then(item =>
    item ? [{ text: item.codigo + ' - ' + item.descricao, value: item.codigo }] : [],
  );
